"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: "reservationStockDialog",
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    isShow: {
      type: Boolean,
      default: true
    },
    reservationData: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    specType: {
      // false:单规格  true:多规格
      type: Boolean,
      default: 0
    }
  },
  data: function data() {
    return {
      visible: false,
      batchStockValue: 0,
      itemKey: 0,
      reservationDataNew: []
    };
  },
  watch: {
    dialogVisible: function dialogVisible(newVal) {
      if (newVal) {
        this.itemKey = Math.random();
        this.reservationDataNew = this.reservationData;
      }
    }
  },
  methods: {
    handleClose: function handleClose() {
      this.$emit("close");
      this.visible = false;
    },
    close: function close() {
      this.visible = false;
      this.batchStockValue = 0;
    },
    batchUpdateStock: function batchUpdateStock() {
      // 使用 for...of 循环替代 forEach，便于后续可能的提前终止操作
      var _iterator = _createForOfIteratorHelper(this.reservationDataNew),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          var _iterator2 = _createForOfIteratorHelper(item.attrValueReservationList),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var res = _step2.value;
              res.stock = this.batchStockValue;
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      this.itemKey = Math.random();
      // 关闭批量修改弹窗并重置值
      this.close();
    },
    submitOk: function submitOk() {
      this.$emit("submitOk", this.reservationDataNew);
      this.visible = false;
    },
    handleStockInput: function handleStockInput(value, item) {
      var num = parseInt(value);
      if (isNaN(num) || num < 0) {
        item.stock = 0;
      } else if (num > 99999) {
        item.stock = 99999;
      } else {
        item.stock = num;
      }
    }
  }
};